import axios from '../utils/axios';

const pdfPath = ({ id, isCoverLetter, shareToken }) => {
	if (shareToken) {
		return `resume-share/${shareToken}/pdf`;
	}

	return isCoverLetter ? `cover-letters/${id}/pdf` : `resumes/${id}/pdf`;
};

export const downloadPdf = ({ id, isCoverLetter, shareToken }, filename, onProgress) => {
	return new Promise((resolve, reject) => {
		const path = pdfPath({ id, isCoverLetter, shareToken });

		axios.get(`/api/${path}`, {
			responseType: 'blob',
			headers: {
				Accept: 'application/pdf'
			},
			onDownloadProgress: (event) => {
				if (event.lengthComputable) {
					const percent = Math.round((event.loaded * 100) / event.total);
					onProgress?.(percent);
				}
			}
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${filename  }.pdf`);
			document.body.appendChild(link);
			link.click();

			resolve();
		}).catch((err) =>  {
			reject(err);
		});
	});
};

export const fetchPdfBlob = async ({ id, isCoverLetter }) => {
	const response = await axios.get(`/api/${pdfPath({ id, isCoverLetter })}`, {
		responseType: 'blob',
		headers: {
			Accept: 'application/pdf'
		},
	});

	return response.data;
};
